export enum AssetPageObjectModel {
  AddMetadataButton = 'addMetadataButton',
  AddMetadataFieldName = 'addMetadataFieldName',
  AddMetadataFieldType = 'addMetadataFieldType',
  AddMetadataFieldValue = 'addMetadataFieldValue',
  AddToCompareButton = 'addToCompareButton',
  AddToCompareIcon = 'addToCompareIcon',
  AddToCompareMenu = 'addToCompareMenu',
  AdvancedAnalysisButton = 'advancedAnalysisButton',
  AssetActionRow = 'assetActionRow',
  DeleteAssetButton = 'deleteAssetButton',
  DownloadAssetButton = 'downloadAssetButton',
  FindMatchesButton = 'findMatchesButton',
  ReprocessAssetButton = 'reprocessAssetButton',
  ViewAssetButton = 'viewAssetButton',
  MissingDependenciesWarningIcon = 'missingDependenciesWarningIcon',
}
